import { LookupAddress } from '../../event/models/lookup-address';
import { LookupContact } from '../../event/models/lookup-contact';
import { Record } from 'immutable';

const PropertyLookupDetailRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  contact: new LookupContact({}),
  address: new LookupAddress({}),
  currency: null,
  subscriber: false,
  manuallyAdded: null,
  statusFlag: null
});

export class PropertyLookupDetail extends PropertyLookupDetailRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  contact: LookupContact;
  address: LookupAddress;
  currency: string;
  subscriber: boolean;
  manuallyAdded: boolean;
  statusFlag: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/property-lookup-detail.ts